import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ce_admin_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// If a protected admin call comes back 401, clear the stale token and redirect
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = (error?.config?.url || "").toString();
    // Only auto-logout on 401 from protected admin routes, not from the login attempt itself
    if (status === 401 && !url.includes("/auth/login")) {
      const hadToken = !!localStorage.getItem("ce_admin_token");
      if (hadToken) {
        localStorage.removeItem("ce_admin_token");
        if (window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/admin/login")) {
          window.location.assign("/admin/login");
        }
      }
    }
    return Promise.reject(error);
  }
);

export const isRestaurantOpen = (openingHours) => {
  if (!openingHours) return true;
  const now = new Date();
  const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const day = days[now.getDay()];
  const dh = openingHours[day];
  if (!dh || !dh.open || !dh.close) return false;
  const [oh, om] = dh.open.split(":").map(Number);
  const [ch, cm] = dh.close.split(":").map(Number);
  const cur = now.getHours() * 60 + now.getMinutes();
  const start = oh * 60 + om;
  const end = ch * 60 + cm;
  return cur >= start && cur <= end;
};
